import { addMilliseconds, milliseconds } from 'date-fns';
import { makeAutoObservable } from 'mobx';

import { eachOfInterval, parseTimeZoneToHours } from '../utils';

type ZoneVariants = 'user' | 'well';

export class TimeZonesStore {
  list = eachOfInterval(-12, 14, 1);

  userTimeZone = -new Date().getTimezoneOffset() / 60;

  wellTimeZone: number | null = null;

  timeZone: ZoneVariants;

  constructor(
    init: ZoneVariants,
    private onChange: (value: ZoneVariants) => void,
  ) {
    this.timeZone = init;
    makeAutoObservable(this);
  }

  get current() {
    return (new Date().getTimezoneOffset() + this.selected * 60) * 60000;
  }

  get selectedMs() {
    return this.selected * milliseconds({ hours: 1 });
  }

  select(value: 'user' | 'well') {
    this.timeZone = value;
    this.onChange(this.timeZone);
  }

  get getDate() {
    const current = this.current;
    return (date: number) => addMilliseconds(date, current);
  }

  getInverDate(date: number) {
    return addMilliseconds(date, -this.current);
  }

  setWellTimeZoneByString(wellZone: string) {
    if (wellZone) {
      this.wellTimeZone = parseTimeZoneToHours(wellZone);
    }
  }

  get selected() {
    if (this.timeZone === 'well') {
      return this.wellTimeZone ?? 0;
    }
    return this.userTimeZone;
  }

  get userTimeZoneTitle() {
    return TimeZonesStore.getHours(this.userTimeZone);
  }

  get wellTimeZoneTitle() {
    if (this.wellTimeZone === null) {
      return null;
    }
    return TimeZonesStore.getHours(this.wellTimeZone);
  }

  static getHours(hours: number) {
    const isNegative = hours < 0;
    const absHours = Math.abs(hours);
    const wholeHours = Math.floor(absHours);
    const minutes = Math.round((absHours - wholeHours) * 60);
    return { isNegative, wholeHours, minutes };
  }
}
